import { BaseService } from '../base.service';

export class PrefecturesService extends BaseService {
  static get resourceEndpoint() {
    return 'owners/prefectures';
  }
}